export default __webpack_public_path__ + "static/media/left-mobile-purple.4f017e50.svg";